import axiosInstance from "../axiosInstance";

const BASE_URL = process.env.REACT_APP_API_URL;
const STAGE = process.env.REACT_APP_API_STAGE;

export const createOrganisationApi = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      BASE_URL + `v1/${STAGE}/dashboard/organisation`,
      payload
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const updateOrganisationApi = async (payload: any) => {
  try {
    const response = await axiosInstance.put(
      BASE_URL + `v1/${STAGE}/dashboard/organisation/${payload._id}`,
      { name: payload.name }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getOrganisationApi = async () => {
  try {
    const response = await axiosInstance.get(
      BASE_URL + `v1/${STAGE}/dashboard/organisation`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
